module.exports = __webpack_public_path__ + "img/arrow-next.2fbec3cc.svg";